/**
 * Punto de Venta de Servicios (walk-in)
 *
 * Cobro rapido de servicios sin necesidad de HC previa.
 */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { atencionesAPI, comprobantesAtencionAPI } from '../services/api';
import ModalCobrarAtencion from '../components/ModalCobrarAtencion';

const PuntoVentaServicios = () => {
  const [showModal, setShowModal] = useState(false);
  const [ultimas, setUltimas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadUltimas(); }, []);

  const loadUltimas = async () => {
    try {
      setLoading(true);
      const res = await atencionesAPI.getAll({ limit: 8 });
      if (res.data.success) setUltimas(res.data.data);
    } catch (e) {
      // silent
    } finally {
      setLoading(false);
    }
  };

  const abrirPDF = async (comprobanteId) => {
    try {
      const res = await comprobantesAtencionAPI.descargarPDF(comprobanteId);
      const url = URL.createObjectURL(res.data);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { toast.error('Error al abrir PDF'); }
  };

  const abrirTicket = async (comprobanteId) => {
    try {
      const res = await comprobantesAtencionAPI.descargarTicket(comprobanteId);
      const url = URL.createObjectURL(res.data);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { toast.error('Error al abrir ticket'); }
  };

  const totalHoy = ultimas.filter(a => {
    const hoy = new Date().toDateString();
    return new Date(a.created_at).toDateString() === hoy && a.estado === 'completada';
  }).reduce((s, a) => s + parseFloat(a.total || 0), 0);

  return (
    <div>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-start mb-4 flex-wrap gap-3">
        <div>
          <h1 className="h3 mb-1 fw-bold">
            <i className="bi bi-cash-stack me-2" style={{ color: '#0984e3' }}></i>
            Punto de Venta · Servicios
          </h1>
          <p className="text-muted mb-0 small">Cobra consultas, exámenes y procedimientos con comprobante interno</p>
        </div>
        <button className="btn btn-primary btn-lg fw-bold" onClick={() => setShowModal(true)}>
          <i className="bi bi-plus-circle-fill me-2"></i>Nueva atención
        </button>
      </div>

      {/* Hero CTA */}
      <div className="card border-0 shadow-sm mb-4" style={{ background: 'linear-gradient(135deg, #0984e3 0%, #6c5ce7 100%)', color: 'white' }}>
        <div className="card-body p-4">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h3 className="fw-bold mb-2"><i className="bi bi-lightning-charge-fill me-2"></i>Cobro rápido de servicios</h3>
              <p className="mb-0 opacity-75">Selecciona servicios del catálogo, aplica descuentos si corresponde, cobra en efectivo, tarjeta, transferencia, mixto o crédito. Se genera automáticamente el comprobante interno con PDF profesional y ticket térmico.</p>
            </div>
            <div className="col-md-4 text-md-end mt-3 mt-md-0">
              <button className="btn btn-light btn-lg fw-bold" onClick={() => setShowModal(true)}>
                <i className="bi bi-plus-lg me-2"></i>Iniciar atención
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Stats rápidas */}
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">Total atenciones hoy</div>
                  <div className="h3 mb-0 fw-bold" style={{ color: '#00b894' }}>${totalHoy.toFixed(2)}</div>
                </div>
                <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 48, height: 48, background: 'rgba(0,184,148,0.15)' }}>
                  <i className="bi bi-cash fs-3" style={{ color: '#00b894' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">Atenciones recientes</div>
                  <div className="h3 mb-0 fw-bold" style={{ color: '#0984e3' }}>{ultimas.length}</div>
                </div>
                <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 48, height: 48, background: 'rgba(9,132,227,0.15)' }}>
                  <i className="bi bi-clock-history fs-3" style={{ color: '#0984e3' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">Tipo de comprobante</div>
                  <div className="h5 mb-0 fw-bold" style={{ color: '#6c5ce7' }}>CS-YYYY-#####</div>
                </div>
                <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 48, height: 48, background: 'rgba(108,92,231,0.15)' }}>
                  <i className="bi bi-receipt fs-3" style={{ color: '#6c5ce7' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Ultimas atenciones */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white border-0 py-3">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0 fw-bold"><i className="bi bi-list-ul me-2"></i>Últimas atenciones</h5>
            <a href="/atenciones" className="btn btn-sm btn-link text-decoration-none">Ver historial completo <i className="bi bi-arrow-right"></i></a>
          </div>
        </div>
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
          ) : ultimas.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <i className="bi bi-inbox fs-1 mb-3 d-block"></i>
              <p className="mb-0">Aún no hay atenciones registradas</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="ps-3">Código</th>
                    <th>Comprobante</th>
                    <th>Paciente</th>
                    <th>Fecha</th>
                    <th className="text-end">Total</th>
                    <th>Pago</th>
                    <th>Estado</th>
                    <th className="text-end pe-3">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {ultimas.map(a => (
                    <tr key={a.id}>
                      <td className="ps-3"><span className="badge bg-light text-dark fw-bold">{a.codigo}</span></td>
                      <td className="fw-bold" style={{ color: '#0984e3' }}>{a.comprobante_numero || '-'}</td>
                      <td>
                        {a.nombres || a.apellidos || a.razon_social
                          ? <><div className="small fw-medium">{a.razon_social || `${a.nombres || ''} ${a.apellidos || ''}`.trim()}</div>
                              <div className="text-muted" style={{ fontSize: '.75rem' }}>{a.identificacion}</div></>
                          : <span className="text-muted small">Consumidor Final</span>}
                      </td>
                      <td className="small">{new Date(a.created_at).toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' })}</td>
                      <td className="text-end fw-bold">${parseFloat(a.total).toFixed(2)}</td>
                      <td><span className="badge bg-secondary-subtle text-secondary">{(a.metodo_pago || '').replace('_', ' ')}</span></td>
                      <td>
                        {a.estado === 'completada'
                          ? (a.es_credito && parseFloat(a.saldo_pendiente) > 0.01
                            ? <span className="badge bg-warning-subtle text-warning">Crédito</span>
                            : <span className="badge bg-success-subtle text-success">Pagada</span>)
                          : <span className="badge bg-danger-subtle text-danger">Anulada</span>}
                      </td>
                      <td className="text-end pe-3">
                        <div className="btn-group btn-group-sm">
                          <button className="btn btn-outline-primary" title="PDF" onClick={() => abrirPDF(a.comprobante_id)} disabled={!a.comprobante_id}>
                            <i className="bi bi-file-earmark-pdf"></i>
                          </button>
                          <button className="btn btn-outline-secondary" title="Ticket" onClick={() => abrirTicket(a.comprobante_id)} disabled={!a.comprobante_id}>
                            <i className="bi bi-receipt"></i>
                          </button>
                          <a className="btn btn-outline-dark" href={`/atenciones?id=${a.id}`} title="Detalle">
                            <i className="bi bi-eye"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <ModalCobrarAtencion
        show={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={() => loadUltimas()}
      />
    </div>
  );
};

export default PuntoVentaServicios;
